module.exports = __webpack_public_path__ + "static/img/animales_30.d46195e6.jpeg";